import React from "react";
import orderBy from "lodash/orderBy";
import EditorSessionTable from "./EditorSessionTable";
import ToolTip from "../../../../parts/tooltip-portal";
import PropTypes from "prop-types";
import SvgIcon from "../../../../parts/SvgIcon";

class EditorWeekColumn extends React.Component {
  constructor(props) {
    super(props);

    this._exerciseListForSession = this._exerciseListForSession.bind(this);
  }

  _exerciseListForSession(session, sessionIndex) {
    const exerciseList =
      session && session.exercises
        ? this.props.exercises.filter((ex) => {
            return session.exercises.find((exId) => ex._id === exId);
          })
        : [];

    const keyId = `editor_session_table${sessionIndex}_${this.props.column}`;

    return (
      <EditorSessionTable
        {...this.props}
        isProgramEditor={true}
        altClass="alt-week-view"
        exerciseList={exerciseList}
        sessionIndex={sessionIndex}
        session={session}
        keyId={keyId}
        key={keyId}
        opacity={
          this.props.editingWorkouts.length &&
          !this.props.editingWorkouts.includes(keyId)
        }
        workoutOpacityCallback={this.props.workoutOpacityCallback}
        exercisesInClipboard={this.context?.locals?.query?.exercisesInClipboard}
      />
    );
  }

  render() {
    const {
      week,
      cycle,
      program,
      programNumber,
      column,
      selectedWeeks,
      handleSelectWeek,
      numberOfWeeks,
    } = this.props;

    const sessions = orderBy(week, "order");

    // If there is only one week, the second column will be undefined
    if (!week) return <span />;
    const selecting = selectedWeeks?.length > 0;
    const selected = selectedWeeks?.includes(sessions[0].week);
    const unchecked = selecting && !selected;

    const storeType = cycle.storeType || "programs";
    const notSingleWorkout = storeType !== "single-workout";

    return (
      <li
        className={`week${unchecked ? " unchecked" : ""}${
          selecting ? " selecting" : ""
        }`}
        key={`week_column_${column}`}
      >
        {notSingleWorkout && (
          <header>
            <div>
              <p className="s2 clipped">Week {sessions[0].week}</p>
              {!!handleSelectWeek && !!selectedWeeks && numberOfWeeks > 1 ? (
                <button
                  className="p-0"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSelectWeek(sessions[0].week);
                  }}
                >
                  <SvgIcon
                    src={
                      selected
                        ? "/img/new-icons/checked-square.svg"
                        : "/img/new-icons/unchecked-square.svg"
                    }
                    noFilterOnLight={selected}
                  />
                </button>
              ) : null}
            </div>
            <div className={selecting ? "invisible" : ""}>
              <ToolTip body="Duplicate Week">
                <a
                  data-button-type="secondary"
                  role="button"
                  href={`/actions/refresh/?modal[type]=duplicate-week&week=${sessions[0].week}`}
                >
                  <SvgIcon src="/img/new-icons/duplicate.svg" />
                </a>
              </ToolTip>

              <ToolTip body="Week Progression">
                <a
                  data-button-type="secondary"
                  role="button"
                  href={`/actions/refresh/?modal[type]=progression&week=${sessions[0].week}&program=${programNumber}&cycle=${cycle._id}&type=week`}
                >
                  <SvgIcon src="/img/new-icons/percentage-square.svg" />
                </a>
              </ToolTip>

              <ToolTip id={`delete-week-${column}`} body="Delete Week">
                <a
                  data-button-type="secondary"
                  role="button"
                  href={`/actions/cycle/delete-week/${cycle._id}/${programNumber}/${sessions[0].week}`}
                >
                  <SvgIcon src="/img/new-icons/red-trash.svg" noFilterOnLight />
                </a>
              </ToolTip>
            </div>
          </header>
        )}
        <ul className="workouts">
          {sessions.map(this._exerciseListForSession)}
        </ul>
        {week.length < 7 && !selecting && notSingleWorkout && (
          <a
            className="add-workout"
            href={`/actions/cycle/addWorkout/${cycle._id}?program=${program.order}&week=${column}`}
          >
            <SvgIcon
              src="/img/new-icons/add-square-outline.svg"
              className="h-11 w-11"
            />
            <p className="p4">Add Workout</p>
          </a>
        )}
      </li>
    );
  }
}
EditorWeekColumn.contextTypes = { locals: PropTypes.object };

export default EditorWeekColumn;
